import type { PartyProduct } from '../types';

import type {
    Cart,
    CartItem,
} from '@/pages/Cart/types';

export interface UnitOption {
    slug: string;
    name: string;
}

export function getUnitSlug(product: PartyProduct) {
    return product.primary_unit_slug
        || product.primary_unit_name
            ?.toLowerCase()
            .replace(/\s+/g, '-')
        || null;
}

// Units a buyer can order this product in. The list ships a single price, so
// the backend prices whichever unit is chosen when the item is added.
export function getUnitOptions(product: PartyProduct): UnitOption[] {
    const options: UnitOption[] = [];
    const primarySlug = getUnitSlug(product);
    if (primarySlug) {
        options.push({
            slug: primarySlug,
            name: product.primary_unit_name || 'Primary unit',
        });
    }
    if (product.secondary_unit_slug && product.secondary_unit_name) {
        options.push({
            slug: product.secondary_unit_slug,
            name: product.secondary_unit_name,
        });
    }
    return options;
}

export function getCartLine(
    cart: Cart | null,
    productSlug: string,
): CartItem | undefined {
    if (!cart?.items) return undefined;
    return cart.items.find(
        (entry) => entry.product_slug === productSlug,
    );
}
